/**
 * 共通受付照会API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 開通受付共通情報
 */
export interface Sgkb575aResProvisionacceptanceCommonInfo {
    /** 
     * 開通受付番号：半角数字
     */
    provAceptNo?: string;
    /** 
     * 開通受付履歴番号：半角数字
     */
    provAceptRrkno?: string;
    /** 
     * 更新通番号：半角数字
     */
    updateSrno?: string;
    /** 
     * 更新区分：半角英数混在
     */
    updateDiv?: string;
    /** 
     * 更新区分名称：全角半角混在
     */
    updateDivAname?: string;
    /** 
     * 開通種別コード：半角英数混在
     */
    provClsfy?: string;
    /** 
     * 開通種別コード名称：全角半角混在
     */
    provClsfyAname?: string;
    /** 
     * 外部接続番号：半角英数混在
     */
    extCnnctNo?: string;
    /** 
     * 開通ステータス：半角英数混在
     */
    provSts?: string;
    /** 
     * 開通ステータス名称：全角半角混在
     */
    provStsAname?: string;
    /** 
     * SW用お客さま名義カナ：全角カナ
     */
    forswitchVisitornameKana?: string;
    /** 
     * SW用お客さま名義漢字：全角文字
     */
    forswitchVisitornameKanji?: string;
    /** 
     * お申し出者種別コード：半角英数混在
     */
    applicantClscode?: string;
    /** 
     * お申し出者種別コード名称：全角半角混在
     */
    applicantClsfyCodeaname?: string;
    /** 
     * エネルギー種別コード：半角英数混在
     */
    energyClscode?: string;
    /** 
     * エネルギー種別コード名称：全角半角混在
     */
    energyClsfyCodeaname?: string;
    /** 
     * マスタ反映時日付使用可否フラグ：半角英数混在
     */
    masterhaneijiDateUsenoflag?: string;
    /** 
     * マスタ反映時日付使用可否フラグ名称：全角半角混在
     */
    masterhaneijiDateUsenoflagAname?: string;
}
